import { NavItemOption, NavItemPageOptions } from './types';
import {
  BookOpen,
  Film,
  User,
  Users,
  Video,
  Monitor,
  Layers,
  Activity,
  FileText,
  Clock,
} from 'react-feather';

const contentSection: NavItemOption[] = [
  {
    href: '/presentations',
    icon: BookOpen,
    title: 'Presentations',
  },
  {
    href: '/slides',
    icon: Film,
    title: 'Slides',
  },
  {
    href: '/forms',
    icon: FileText,
    title: 'Forms',
  },
  {
    href: '/assets',
    icon: Video,
    title: 'Media / Assets',
  },
  {
    href: '/scheduler',
    icon: Clock,
    title: 'Playlists & Scheduler',
  },

  {
    href: '/kvs',
    icon: Layers,
    title: 'Key-Value Store (KVS)',
  },
];

const hardwareSection: NavItemOption[] = [
  {
    href: '/devices',
    icon: Monitor,
    title: 'Devices & Screens',
  },
];

const settingsSection: NavItemOption[] = [
  {
    href: '/profile',
    icon: User,
    title: 'Organization Profile',
  },
  {
    href: '/users',
    icon: Users,
    title: 'Users & Roles',
  },
];

const navItems: NavItemPageOptions[] = [
  {
    title: 'Content',
    pages: contentSection,
  },
  {
    title: 'Hardware',
    pages: hardwareSection,
  },
  {
    title: 'Settings',
    pages: settingsSection,
  },
];

export const navSuperAdminItems: NavItemPageOptions[] = [
  {
    title: 'Settings',
    pages: [
      {
        href: '/admin/organizations',
        icon: Users,
        title: 'Platform Admin',
      },
      {
        href: '/admin/activity-log',
        icon: Activity,
        title: 'Activity & Audit Logs',
      },
    ],
  },
];

export default navItems;
